import gql from 'graphql-tag';

export const Telecos = gql`
  query GetAllTelecos {
    telcos {
      id
      name
      displayname
    }
  }
`;

export const QueryTransaction = gql`
  query GetAllTransactions($querytype: String!, $queryvalue: String) {
    transactions(querytype: $querytype, queryvalue: $queryvalue) {
      id
      msisdn
      currency
      providerCode
      amount
      referenceid
      language
      insightReference
      transactionID
      description
      code
      details
      resultType
      resultCode
      resultDesc
      originatorConversationId
      conversationId
      transactiontime
      thirdPartyReference
      operator
      user
      txnstatus
      exchangerate
      extrefnum
      createdAt
      originatingID
    }
  }
`;



// WEBPACK FOOTER //
// ./src/views/Transactions/querytrans.js